import { useDispatch, useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'
import MaterialCard from '../../../materials/MaterialCard'
import MCElement from '../../../common/MCElement'
import { addAcceptedMaterial, addRefusedMaterial } from '../../../../reducers/programRegistrationReducer'
import { getNegativeToggleText, getPositiveToggleText } from '../../../../utility/materials'

import './ProgramMaterialsStep.scss'
import colors from '../../../../assets/styles/globals.scss'

const ProgramMaterialsStep = () => {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const { courseMaterials } = useSelector(state => state.programRegistration.enrollmentData)
  const { acceptedMaterials, refusedMaterials } = useSelector(state => state.programRegistration)

  const handleAcceptMaterial = (m) => {
    if (!isMaterialAccepted(m)) {
      dispatch(addAcceptedMaterial(m))
    }
  }
  const handleRefuseMaterial = (m) => {
    if (!isMaterialRefused(m)) {
      dispatch(addRefusedMaterial(m))
    }
  }

  const isMaterialAccepted = (material) => !!acceptedMaterials[material.id]
  const isMaterialRefused = (material) => !!refusedMaterials[material.id]

  return (
    <div id='ProgramMaterialsStep' className='d-flex flex-column'>
      <div id='MaterialsSelection'>
        <h3 className='step-label mb-3'>{t('programs.registration.materialsStep.title')}</h3>
        <h5 className='step-label mb-3'>
          {t('programs.registration.materialsStep.instructions')}
        </h5>
        <div className='mt-4'>
          {courseMaterials.map(m => (
            <div key={m.id} className='material-card-container'>
              <MaterialCard material={m} />
              <div className='mt-3'>
                <h5 className='step-label mb-3'>
                  {t(m.name === 'Operation 36 Junior Starter Kit'
                    ? 'programs.registration.materialsStep.doYouNeedAn'
                    : 'programs.registration.materialsStep.doYouNeed', { name: m.name })}
                </h5>
                <div>
                  {/* eslint-disable-next-line jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions */}
                  <div
                    className='d-flex align-items-center mb-2 action'
                    onClick={() => handleAcceptMaterial(m)}
                  >
                    <MCElement
                      type='radio'
                      onKeyDown={(e) => { e.key === 'Enter' && handleAcceptMaterial(m) }}
                      isSelected={isMaterialAccepted(m)}
                      primaryColor={isMaterialAccepted(m) ? colors.secondaryColor : colors.lightNavy}
                    />
                    <span className='ml-3'>{t(getPositiveToggleText(m), { name: m.name })}</span>
                  </div>
                  {/* eslint-disable-next-line jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions */}
                  <div
                    className='d-flex align-items-center action'
                    onClick={() => handleRefuseMaterial(m)}
                  >
                    <MCElement
                      type='radio'
                      onKeyDown={(e) => { e.key === 'Enter' && handleRefuseMaterial(m) }}
                      isSelected={isMaterialRefused(m)}
                      primaryColor={isMaterialRefused(m) ? colors.secondaryColor : colors.lightNavy}
                    />
                    <span className='ml-3'>{t(getNegativeToggleText(m), { name: m.name })}</span>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}

export default ProgramMaterialsStep
